import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = ({ onCartClick, cartItemCount = 0 }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  // Custom Link component that closes the mobile menu when clicked
  const NavLink = ({ to, children, ...props }) => {
    return (
      <Link 
        to={to} 
        className={isActive(to) ? 'active' : ''} 
        onClick={closeMobileMenu}
        {...props}
      >
        {children}
      </Link>
    );
  };

  return (
    <header className="header">
      <div className="header-top">
        <div className="container">
          <div className="header-contact">
            <span>
              <i className="fas fa-envelope"></i>
              contactus@greenkleenoman.com
            </span>
            <span>
              <i className="fas fa-phone"></i>
              +968 24708516
            </span>
          </div>
          <div className="header-social">
            <a href="https://www.instagram.com/greenkleen_om/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.facebook.com/greenkleenoman" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://wa.me/96898520852?text=Hi!%20I%E2%80%99m%20interested%20in%20booking%20a%20car%20cleaning.%20Please%20provide%20details%20on%20available%20time%2C%20services%2C%20and%20pricing.
"  target="_blank" rel="noopener noreferrer">
              <i className="fab fa-whatsapp"></i>  
            </a>
          </div>
        </div>
      </div>
      
      <div className="header-main">
        <div className="container">
          <div className="nav-container">
            <Link to="/" className="logo" onClick={closeMobileMenu}>
              <img src="/img/logo/GreenKleen.logo.png" alt="Green Kleen Logo" />
            </Link>
            
            <nav className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
              <NavLink to="/">
                Home
              </NavLink>
              <NavLink to="/shop">
                Shop
              </NavLink>
              <NavLink to="/car-wash-trolley">
                Car Wash Trolley
              </NavLink>
              <NavLink to="/gallery">
                Gallery
              </NavLink>
              {/* <NavLink to="/voucher">
                Voucher
              </NavLink> */}
              <NavLink to="/loyalty-program">
                Loyalty Program
              </NavLink>
              <NavLink to="/contact">
                Contact
              </NavLink>
           
            </nav>
            <a href="https://wa.me/96898520852?text=Hi!%20I%E2%80%99m%20interested%20in%20booking%20a%20car%20cleaning.%20Please%20provide%20details%20on%20available%20time%2C%20services%2C%20and%20pricing.
"   className="btn btn-outline-header" onClick={closeMobileMenu}>
                        Book Service
                      </a>
            
            <div className="header-actions">
              {/* <button className="cart-btn" onClick={onCartClick}>
                <i className="fas fa-shopping-cart"></i>
                {cartItemCount > 0 && <span className="cart-badge">{cartItemCount}</span>}
              </button> */}
              <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
                <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;